export const auth = {
  login: "تسجيل الدخول",
  register: "إنشاء حساب جديد",
  phone: "رقم الجوال",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  confirmPassword: "تأكيد كلمة المرور",
  name: "الاسم الكامل",
  verifyOTP: "التحقق من الرمز",
  otpSent: "تم إرسال رمز التحقق إلى رقمك",
  enterOTP: "أدخل رمز التحقق",
  resendOTP: "إعادة إرسال الرمز",
  forgotPassword: "نسيت كلمة المرور؟",
  createAccount: "إنشاء حساب",
  haveAccount: "لديك حساب؟ سجل دخولك",
  noAccount: "ليس لديك حساب؟ أنشئ حساباً جديداً",
  phoneRequired: "رقم الجوال مطلوب",
  passwordRequired: "كلمة المرور مطلوبة",
  nameRequired: "الاسم مطلوب",
  invalidPhone: "رقم الجوال غير صحيح",
  invalidEmail: "البريد الإلكتروني غير صحيح",
  passwordMismatch: "كلمات المرور غير متطابقة"
};